'use strict';
//require('babel-polyfill');

window.jQuery = window.$ = require('jquery');

require('bootstrap-sass/assets/javascripts/bootstrap/dropdown');
require('bootstrap-sass/assets/javascripts/bootstrap/collapse');
require('bootstrap-sass/assets/javascripts/bootstrap/modal');
require('bootstrap-sass/assets/javascripts/bootstrap/transition');
require('lightbox2');
require('./components/sticky');
require('./components/counter');
require('./components/form.calculator');
require('./components/form.gasCalculator');
require('./components/form.leadbox');
require('./components/ajaxForm');
require('./components/jquery.dataBlockToggle');
require('./components/jquery.isOnScreen');
require('./components/jquery.maphilight');
require('./components/jquery.showAndTell');
require('./components/chargingStationMap');
require('./components/customBanner');
require('./components/searchTerms');
require('./scripts/initSocialButtons');
require('./scripts/articleLists');
require('./scripts/pushNotification.js');
require('./scripts/newsletter.js');
require('./scripts/homepage.js');
require('./scripts/articleDetail.js');
require('./scripts/calculation.js');
require('./scripts/calculator.js');
require('./components/sticky.fixer.js');
require('jquery-inview');
require('./components/ppConnectMail');
require('./scripts/navbar');
require('./scripts/modalSendComparisonEmail');
require('./scripts/nextListRow')

import Video from './components/video';
import ScrollTo from './components/scrollTo';
import * as formValidation from './components/form.validation';

$(function() {
    $('form').dataBlockToggle({
        rowSelector: '.form-group'
    });
    // form validace musi byt inicializovane se spozdenim
    // definice formularu se nacita az nasledne
    setTimeout(function () {
        formValidation.setCustomizeValidators();
    }, 1);

    $(document).ready(function (){
        $("#btn-form-photovoltaic").click(function (){
            $('html, body').animate({
                scrollTop: $("#form-photovoltaic").offset().top
            }, 1500);
        });
    });
});



// WEBPACK FOOTER //
// ./app/Resources/assets/js/scripts.js